/**
 * This code was migrated from webclient. For the original file's history, see
 * https://github.com/Gousto/gousto-webclient/blob/1544f0f8/src/apps/webclient/src/config/service-environment/service-environment.types.ts
 */

import type { Domain, PROTOCOL_PREFIX } from '@library/environment'
import type { Nullable } from '@library/type-utils'

export type ServiceVersion = {
  version: string
  majorVersion: number
  basePath: string
  /**
   * Whether the API gateway strips `basePath` before forwarding the request to the upstream
   * service. Defaults to `true`: for most services `basePath` is purely a gateway routing prefix
   * that the service itself does not serve, so direct (server-side) calls to `${env}-<service>`
   * must omit it. Set to `false` when the gateway forwards the path unchanged (e.g. an nginx
   * `proxy_pass` with no URI part) — the service then serves `basePath` directly, so it must be
   * retained on server-side calls too.
   */
  apiGatewayStripsBasePath?: boolean
}

/* eslint-disable no-shadow,no-unused-vars */
export enum OVERRIDDEN_SERVICE_PATTERNS {
  loggingmanager = 'loggingmanager',
  webclient = 'webclient',
}

export type ServiceName =
  | 'auth'
  | 'brand'
  | 'cmsreadbroker'
  | 'complaints'
  | 'cookbook'
  | 'core'
  | 'customers'
  | 'deliveries'
  | 'experimentation'
  | 'loggingmanager'
  | 'menu'
  | 'menuexperience'
  | 'onboardingexperienceapi'
  | 'order'
  | 'orders'
  | 'orderskiprecovery'
  | 'payments'
  | 'paymentmethodquery'
  | 'products'
  | 'ssr'
  | 'ssrrecipecards'
  | 'subpauseosr'
  | 'subscriptioncommand'
  | 'subscriptionquery'
  | 'tastepreferences'
  | 'userfeedback'
  | 'webclient'
  | 'workable'

export type ServiceManifest = {
  [key in ServiceName]: ServiceVersion[]
}

export enum SERVICE_DOMAINS {
  local = 'gousto.local',
  production = 'gousto.co.uk',
  default = 'gousto.info',
}

export type ServiceUrlProperties = {
  basePath?: Nullable<string>
  majorVersion?: number
  environmentName: string
  port?: number
  protocol: PROTOCOL_PREFIX
  serviceName: ServiceName
  serviceDomain: Domain
  /**
   * Whether the request is served through the public API gateway (`${env}-api`) rather than
   * directly to the service host (`${env}-<service>`).
   */
  serveFromGateway: boolean
}

export type ServiceEnvironment = {
  environmentName: string
  protocol: PROTOCOL_PREFIX
  serviceDomain: Domain
}
